module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_new2/pc/item_04_fa4d1c6e728e63a2db89b1f1ba75ad28.jpg";